import React from 'react';
import Card from '../../../../../components/Card/Card';
import Button from '../../../../../components/Button/Button';
import './LeagueStanding.css';

const LeagueStanding = ({
  teams,
  teamPoints,
  pendingChanges,
  draggedTeam,
  dragOverIndex,
  handlePointsChange,
  handleDragStart,
  handleDragEnd,
  handleDragOver,
  handleDragLeave,
  handleDrop
}) => {
  return (
    <Card className="admin-card">
      <h4>Fase 1 - Ligastilling (Point Tabel)</h4>
      <p>Indtast point for hvert hold.</p>
      
      <div className="points-table-container">
        <table className="points-table">
          <thead>
            <tr className="points-table-header">
              <th className="points-table-header-Position-cell">Position</th>
              <th className="points-table-header-Team-cell">Hold</th>
              <th className="points-table-header-Points-cell">Points</th>
              <th className="points-table-header-Status-cell">Status</th>
            </tr>
          </thead>
          <tbody>
            {teams.map((team, index) => {
              const teamName = team.name || team; // Handle both Team objects and strings
              const points = teamPoints[teamName] || 0;
              const displayPosition = index + 1; // Vis placering baseret på sorteret rækkefølge
              const isDragging = draggedTeam?.team === teamName;
              const isDragOver = dragOverIndex === index;
              
              return (
                <tr 
                  key={teamName} 
                  className={`${displayPosition <= 8 ? 'top-8-row' : displayPosition <= 24 ? 'playoff-row' : 'out-row'} ${isDragging ? 'dragging' : ''} ${isDragOver ? 'drag-over' : ''}`}
                  draggable
                  onDragStart={(e) => handleDragStart(e, teamName, index)}
                  onDragEnd={handleDragEnd}
                  onDragOver={(e) => handleDragOver(e, index)}
                  onDragLeave={handleDragLeave}
                  onDrop={(e) => handleDrop(e, index)}
                >
                  <td className="position-cell">
                    <span className="position-number">{displayPosition}</span>
                    <span className="drag-handle">⋮⋮</span>
                  </td>
                  <td className="team-cell">{teamName}</td>
                  <td className="points-cell">
                    <input
                      type="number"
                      value={points}
                      onChange={(e) => handlePointsChange(teamName, e.target.value)}
                      className={`points-input ${points > 0 ? 'pending-change' : ''}`}
                      min="0"
                      max="100"
                      draggable={false}
                    />
                  </td>
                  <td className="status-cell">
                    {displayPosition <= 8 && <span className="status-badge top-8">Top-8</span>}
                    {displayPosition > 8 && displayPosition <= 24 && <span className="status-badge playoff">Playoff</span>}
                    {displayPosition > 24 && <span className="status-badge out">Out</span>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      
      <div style={{ marginTop: '15px', textAlign: 'center' }}>
        {pendingChanges && (
          <p style={{ fontSize: '0.8rem', color: '#f59e0b', marginBottom: '8px' }}>
            ⚠️ Du har ikke-gemte ændringer. Brug "Gem" knappen i toppen for at gemme alle ændringer.
          </p>
        )}
      </div>
    </Card>
  );
};

export default LeagueStanding;
